import { populate } from "populate";

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "3b389893-d127-4e29-8a22-0c8d568221f8",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "652d485f-ba17-4010-bbee-68e83f339b84",
      type: "Sprite",
      name: "slot",
      nameSpace: "",
      className: "big",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "Polygon",
        path: "0,-60, 95,0, 0,60, -95,0, 0,-60"
      },
      texture: "base_texture",
      parent: "3b389893-d127-4e29-8a22-0c8d568221f8",
      data: ""
    },
    {
      id: "ad0b8644-256a-4eff-b65e-dc0ebcaf70a5",
      type: "Container",
      name: "itemContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "652d485f-ba17-4010-bbee-68e83f339b84",
      data: ""
    },
    {
      id: "26dfc96e-f40b-4336-b86c-08a5a9295105",
      type: "Container",
      name: "taskIcon",
      nameSpace: "",
      className: "",
      x: 0,
      y: 50,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "652d485f-ba17-4010-bbee-68e83f339b84",
      data: ""
    },
    {
      id: "cb9fef5e-06c8-4bf5-b7b3-f50c6856dd60",
      type: "Container",
      name: "replyTaskIcon",
      nameSpace: "",
      className: "",
      x: 0,
      y: 50,
      scale: {
        x: 0.75,
        y: 0.75
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "652d485f-ba17-4010-bbee-68e83f339b84",
      data: ""
    },
    {
      id: "a40a2258-241d-4979-b664-1388b995efc7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "big_tractor",
      parent: "ad0b8644-256a-4eff-b65e-dc0ebcaf70a5",
      data: ""
    },
    {
      id: "5d35a956-84bf-48a3-ac4e-dea5d45df6b8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task_bg",
      parent: "26dfc96e-f40b-4336-b86c-08a5a9295105",
      data: ""
    },
    {
      id: "04a9727e-fd7d-45f3-bc36-f4709592ea64",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task_bg",
      parent: "cb9fef5e-06c8-4bf5-b7b3-f50c6856dd60",
      data: ""
    },
    {
      id: "9d276063-47f9-465a-8576-508e39771d0b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -1,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task_big",
      parent: "5d35a956-84bf-48a3-ac4e-dea5d45df6b8",
      data: ""
    },
    {
      id: "66f34045-5342-4fb0-8847-c125d11961de",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -1,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task_big",
      parent: "04a9727e-fd7d-45f3-bc36-f4709592ea64",
      data: ""
    },
    {
      id: "9068aa27-825d-480d-82fb-098562e9e6ed",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 25,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task",
      parent: "04a9727e-fd7d-45f3-bc36-f4709592ea64",
      data: ""
    }
  ]
} as const;

export class BigSlotLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  slot: GameObject<PIXI.Sprite>;
  itemContainer: GameObject<PIXI.Container>;
  taskIcon: GameObject<PIXI.Container>;
  replyTaskIcon: GameObject<PIXI.Container>;
  big: (GameObject<PIXI.Sprite>)[];

  constructor() {
    populate(this, raw);
  }
}
